import { connect } from 'react-redux';

import { getVisitRequest } from 'datamodel/visits/api';
import { getToken } from 'datamodel/Auth/selectors';
import { getUserId } from 'datamodel/User/selectors';
import VisitOverview from './visit-overview';

const mapStateToProps = (state) => ({
  token: getToken(state),
  userId: getUserId(state),
});

const mergeProps = (state, _, ownProps) => ({
  ...state,
  getVisitRequest: (params) => getVisitRequest({ token: state.token }, params),
  ...ownProps,
});

export default connect(mapStateToProps, null, mergeProps)(VisitOverview);
